// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".layout-switch__container.expanded .icon {\n  transform: rotate(180deg);\n}", "",{"version":3,"sources":["/app/app/javascript/dashboard/routes/dashboard/conversation/search/SwitchLayout.vue"],"names":[],"mappings":"AA+BE;EACE,yBAAA;AA9BJ","file":"SwitchLayout.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.layout-switch__container {\n  &.expanded .icon {\n    transform: rotate(180deg);\n  }\n}\n"]}]);
// Exports
module.exports = exports;
